/**
 * Find references — returns every use-site of the symbol at the cursor.
 */

import type { Location } from "vscode-languageserver";
import type { CursorContext } from "../workspace/cursor-context.js";
import type { SymbolTable } from "../workspace/symbol-table.js";
import type { ReferenceIndex } from "../workspace/reference-index.js";
import type { Workspace } from "../workspace/workspace.js";
import { resolveSymbolAtCursor } from "../workspace/resolve.js";
import { toLspRange } from "../lsp-types.js";

export function provideReferences(
  workspace: Workspace,
  symbols: SymbolTable,
  cursor: CursorContext,
  refs: ReferenceIndex,
  uri: string,
  line: number,
  character: number,
  includeDeclaration: boolean
): Location[] {
  const sym = resolveSymbolAtCursor(workspace, symbols, cursor, uri, line, character);
  if (!sym) return [];

  const locations: Location[] = refs.referencesTo(sym.id).map((r) => ({
    uri: r.uri,
    range: toLspRange(r.span),
  }));

  const declSpan = sym.nameSpan ?? sym.declSpan;
  if (includeDeclaration && sym.definingUri && declSpan) {
    locations.unshift({
      uri: sym.definingUri,
      range: toLspRange(declSpan),
    });
  }

  return locations;
}
